export const innerHTML = `<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
    <path fill="currentcolor" d="M7.348 6.153a.75.75 0 0 1 .967 1.144l-2.818 2.64h10.611a4.75 4.75 0 0 1 4.75 4.75v3.198a.75.75 0 0 1-1.5 0v-3.198a3.25 3.25 0 0 0-3.25-3.25H5.442l2.883 2.807.053.056a.75.75 0 0 1-1.1 1.018l-4.203-4.094-.052-.055a.75.75 0 0 1 .062-1.03L7.29 6.202l.06-.049Z"/>
</svg>
`;
